import { render, staticRenderFns } from "./VcAzureAcs.vue?vue&type=template&id=56f2c4bf&"
import script from "./VcAzureAcs.vue?vue&type=script&lang=js&"
export * from "./VcAzureAcs.vue?vue&type=script&lang=js&"
import style0 from "./VcAzureAcs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports